export default __webpack_public_path__ + "static/media/gif-load.6a1cdfcd.gif";